export default function(name, eventPayload, cb) {
  dispatchEventToAmplitude(name, eventPayload, cb);
}

// Send an event to Amplitude.
const dispatchEventToAmplitude = (name, eventPayload, cb) => {
  if (eventPayload) {
    amplitude.getInstance().logEvent(name, eventPayload, () => {
      if (cb) cb();
    });
  } else {
    amplitude.getInstance().logEvent(name);
  }
};
